(function(){
  const svg=document.getElementById('breathSvg');
  const flower=document.getElementById('flower');
  const orb=document.getElementById('orb');
  const sources=[0,1,2,3].map(i=>document.getElementById('p'+i));
  const energies=[...document.querySelectorAll('.energy-path')];
  const orbRings=[...document.querySelectorAll('.orb-ring')];
  const signals=[...document.querySelectorAll('.signal')];
  const label=document.getElementById('hzLabel');
  const heroRoot=document.querySelector('.bmg-hero--demo');
  const meshOne=heroRoot?.querySelector('.bmg-hero__mesh--one');
  const meshTwo=heroRoot?.querySelector('.bmg-hero__mesh--two');
  const dotField=heroRoot?.querySelector('.bmg-hero__dot-field');
  const sample=document.getElementById('bmgHeroSample');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const TAU=Math.PI*2;
  const EXACT=[
    'M375.45 375.43C375.45 375.43 377.67 532.82 532.69 533.85C686.54 534.88 749.04 474.74 749.04 374.25C749.04 273.76 676.88 204.44 533.83 218.62C533.83 218.62 535.89 365.2 375.45 375.43Z',
    'M376.09 375.42C376.09 375.42 525.84 374.39 532.93 220.7C540.03 67.01 473.7 2.5 373.21 2.5C272.72 2.5 202.86 74.02 217.05 217.07C217.05 217.07 361.44 212.42 376.09 375.42Z',
    'M376.09 375.42C376.09 375.42 372.54 224.09 218.85 217C65.16 209.91 2.5 276.11 2.5 376.6C2.5 477.09 71.11 544.94 217.44 534.87C217.44 534.87 210.47 391.26 376.09 375.41V375.42Z',
    'M375.45 375.43C375.45 375.43 224.12 378.98 217.03 532.67C209.94 686.36 276.14 749.02 376.63 749.02C477.12 749.02 547.79 676.93 533.6 533.88C533.6 533.88 393.31 542.16 375.45 375.43Z'
  ];

  // Each petal is sampled from the exact source path, then morphed to a circular
  // target. This keeps the original artwork untouched at the endpoints while
  // making the intermediate motion a true geometric deformation.
  const N=180;
  function samplePath(path){
    const len=path.getTotalLength(), pts=[];
    for(let i=0;i<N;i++){
      const p=path.getPointAtLength(len*i/(N-1));
      pts.push([p.x,p.y]);
    }
    return pts;
  }
  const sourcePts=sources.map(samplePath);
  const targets=[148,177,207,235].map((r,i)=>{
    const pts=[];
    // Start angle offsets create a slightly layered, non-spinner orb.
    const off=[0.10,-0.04,0.07,-0.08][i];
    for(let j=0;j<N;j++){
      const a=-Math.PI/2+TAU*j/(N-1)+off;
      pts.push([376+r*Math.cos(a),376+r*Math.sin(a)]);
    }
    return pts;
  });

  function pathD(points){
    let d='M '+points[0][0].toFixed(2)+' '+points[0][1].toFixed(2);
    for(let i=1;i<points.length;i++) d+=' L '+points[i][0].toFixed(2)+' '+points[i][1].toFixed(2);
    return d+' Z';
  }
  function lerp(a,b,t){return a+(b-a)*t}
  function easeInOut(t){return t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2}
  function smoothstep(t){return t*t*(3-2*t)}
  function morph(t){
    if(t<=0){ sources.forEach((p,k)=>p.setAttribute('d',EXACT[k])); return; }
    const mt=smoothstep(t);
    sources.forEach((p,k)=>{
      const pts=[];
      for(let i=0;i<N;i++) pts.push([lerp(sourcePts[k][i][0],targets[k][i][0],mt),lerp(sourcePts[k][i][1],targets[k][i][1],mt)]);
      p.setAttribute('d',pathD(pts));
    });
  }

  // A single 0->1->0 inhale/exhale curve, used identically by the orb and by
  // the ambient background so the two are never on separate clocks.
  function breathAt(cycle){
    return cycle<.5 ? easeInOut(cycle/.5) : easeInOut((1-cycle)/.5);
  }

  // Drive the ambient background mesh/dots directly from the same breath
  // value as the orb (their CSS keyframe animation is turned off for this
  // hero in bmg-home.css so there is only ever one source of truth for the
  // motion). v is 0 at rest and 1 at full inhale, matching the retired
  // bmg-breathe-primary-strong / bmg-breathe-secondary-strong / bmg-dot-texture
  // keyframes' own 0%/50%/100% values.
  function updateBg(v){
    if(meshOne){
      meshOne.style.transform='translate3d('+lerp(-5,5,v).toFixed(3)+'%, '+lerp(-3,4,v).toFixed(3)+'%, 0) scale('+lerp(.82,1.18,v).toFixed(4)+')';
      meshOne.style.opacity=lerp(.72,1,v).toFixed(4);
    }
    if(meshTwo){
      meshTwo.style.transform='translate3d('+lerp(5,-5,v).toFixed(3)+'%, '+lerp(4,-4,v).toFixed(3)+'%, 0) scale('+lerp(.84,1.16,v).toFixed(4)+')';
      meshTwo.style.opacity=lerp(.72,1,v).toFixed(4);
    }
    if(dotField){
      dotField.style.transform='translate3d('+lerp(-2,3,v).toFixed(3)+'px, '+lerp(-2,2,v).toFixed(3)+'px, 0) scale('+lerp(.99,1.015,v).toFixed(4)+')';
      dotField.style.opacity=lerp(.24,.4,v).toFixed(4);
      const size=lerp(10,10.6,v).toFixed(3);
      dotField.style.backgroundSize=size+'px '+size+'px';
    }
  }

  // Hold the flower during the sample's opening instructions, then morph
  // into the breathing orb. Playback time is the single timeline.
  const FLOWER_MS=8000;
  const MORPH_MS=2000;
  const BREATH_CYCLE_MS=6000;
  // The public Baseline 30 sample is 60 seconds long.
  const pulseMs=50000;

  let running=false, raf=0;

  function clamp01(x){return Math.max(0,Math.min(1,x))}
  function phaseFor(elapsed){
    if(elapsed<FLOWER_MS) return ['flower',elapsed/FLOWER_MS];
    if(elapsed<FLOWER_MS+MORPH_MS) return ['toOrb',(elapsed-FLOWER_MS)/MORPH_MS];
    const pulseElapsed=elapsed-FLOWER_MS-MORPH_MS;
    if(pulseElapsed<pulseMs) return ['orb',(pulseElapsed%BREATH_CYCLE_MS)/BREATH_CYCLE_MS];
    return ['done',1];
  }

  function draw(){
    if(!running) return;
    const elapsed=(sample?.currentTime || 0)*1000;
    const [state,p]=phaseFor(elapsed);
    if(state==='flower'){
      flower.style.opacity=1; orb.style.opacity=0;
      morph(0);
      const energy=elapsed/1000;
      energies.forEach((e,i)=>e.style.strokeDashoffset=String(-(energy*85+i*170)));
      updateBg(0);
    } else if(state==='toOrb'){
      flower.style.opacity=1; orb.style.opacity=1;
      const m=easeInOut(p); morph(m);
      orb.style.opacity=0.10+0.90*m;
      energies.forEach((e,i)=>e.style.opacity=String(.78*(1-m)));
      orbRings.forEach((r,i)=>r.style.opacity=String((i<4?m:.0)));
      signals.forEach(s=>s.style.opacity=0);
      label.style.opacity=0;
      updateBg(0);
    } else if(state==='orb'){
      flower.style.opacity=0; orb.style.opacity=1;
      morph(1);
      energies.forEach(e=>e.style.opacity=0);
      // One measured 3s-in / 3s-out inhale/exhale cycle, repeating for
      // the length of the pulsing window. The ambient background is driven
      // from the same breath value below so the two never drift apart.
      const cycle=p;
      const breath=breathAt(cycle);
      updateBg(breath);
      const scale=1+0.075*breath;
      orb.setAttribute('transform','translate(376 376) scale('+scale.toFixed(5)+') translate(-376 -376)');
      orbRings.forEach((r,i)=>{
        // No per-ring translate/scale here: the whole orb group above already
        // grows and shrinks in place from its own center. Individually
        // nudging each ring on top of that (the old shimmer effect) scaled
        // some rings from the SVG origin instead of their own center, which
        // is what made the whole shape appear to drift left while growing.
        r.style.opacity=i<4 ? .86 : .38;
        r.style.strokeWidth=(i<4?4:3).toString();
      });
      // Stereo traces enter, meet at the center, then recede. Two waveforms
      // overlap so it reads as a signal interaction rather than an equalizer.
      const cyc=p;
      const local=cyc%1;
      const meet=Math.max(0,1-Math.abs(local-.5)/.5);
      const pulse=Math.pow(Math.max(0,Math.sin(local*TAU)),8);
      const travel=local<.5 ? local*2 : (1-local)*2;
      signals.forEach((s,i)=>{
        const isSoft=i%2===1;
        s.style.opacity=String((isSoft?.25:.58)*meet + pulse*(isSoft?.18:.42));
        s.style.strokeDasharray=isSoft?'10 18':'34 20';
        s.style.strokeDashoffset=String((i%2===0?1:-1)*(travel*220+i*45));
      });
      label.style.opacity=String(Math.min(1,pulse*1.1));
      document.getElementById('innerPulse').style.opacity=String(.32+.35*pulse);
    } else {
      // Sequence complete: settle on a calm, still orb and stop for good.
      // The animation plays once per page load; there is no further loop.
      flower.style.opacity=0; orb.style.opacity=1;
      morph(1);
      orb.removeAttribute('transform');
      energies.forEach(e=>e.style.opacity=0);
      orbRings.forEach((r,i)=>{ r.style.opacity=String(i<4?.86:.38); r.removeAttribute('transform'); });
      signals.forEach(s=>s.style.opacity=0);
      label.style.opacity=0;
      document.getElementById('innerPulse').style.opacity='.32';
      updateBg(0);
      running=false;
      cancelAnimationFrame(raf);
      return;
    }
    raf=requestAnimationFrame(draw);
  }

  function beginSequence(){
    if(reduced.matches || running) return;
    running=true;
    raf=requestAnimationFrame(draw);
  }

  // The visual follows the visitor-started sample. Pausing the audio also
  // freezes the animation; replaying starts again from the flower.
  function applyReduced(){
    if(reduced.matches){
      running=false; cancelAnimationFrame(raf); flower.style.opacity=1; orb.style.opacity=0;
      sources.forEach((p,i)=>p.setAttribute('d',EXACT[i]));
      energies.forEach(e=>e.style.opacity=0); label.style.opacity=0;
      updateBg(0);
    } else if(sample && !sample.paused){
      beginSequence();
    }
  }
  reduced.addEventListener?.('change',applyReduced);
  sample?.addEventListener('play',beginSequence);
  sample?.addEventListener('pause',()=>{running=false;cancelAnimationFrame(raf)});
  sample?.addEventListener('ended',()=>{running=false;cancelAnimationFrame(raf)});
  if(reduced.matches) applyReduced();
})();
